{
  "ancillaries": {
    "loungeCabinBaggage": {
      "extraTitle": "Lounge + Carry-on combo"
    },
    "loungePriority": {
      "extraTitle": "Lounge + Priority combo"
    },
    "loungeWifi": {
      "extraTitle": "Lounge + Internet combo"
    },
    "wifiMeal": {
      "extraTitle": "Internet + Meal combo"
    }
  },
  "badges": {
    "finnairForBusiness": "Work travel benefit"
  },
  "services": {
    "loungeCabinBaggage": {
      "state": {
        "modify": {
          "ariaText": "Modify your combo selection",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combo",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    },
    "loungePriority": {
      "state": {
        "modify": {
          "ariaText": "Modify your combo selection",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combo",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    },
    "loungeWifi": {
      "state": {
        "modify": {
          "ariaText": "Modify your combo selection",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combo",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    },
    "wifiMeal": {
      "state": {
        "modify": {
          "ariaText": "Modify your combo selection",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combo",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    }
  },
  "shoppingCart": {
    "closeCart": "Close cart"
  }
}
